import { defineChain } from '@reown/appkit/networks'
// Define the custom network
export const MonadTestnet = defineChain({
  id: 10143,
  caipNetworkId: 'eip155:123456789',
  chainNamespace: 'eip155',
  name: 'Monad testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Monad',
    symbol: 'MON'
  },
  rpcUrls: {
    default: {
      http: ['https://monad-testnet.g.alchemy.com/v2/aGZVkn-ixj00qoEMyIgc1RKX09QXJbeS']
    }
  },
  blockExplorers: {
    default: { name: 'Monad Block Explorer', url: 'https://testnet.monadexplorer.com/' }
  }
})
